// app/javascript/controllers/facebook_pixel_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    event: String,           // "Lead", "ViewContent", etc.
    eventId: String,         // For deduplication (from server OR generated)
    params: { type: Object, default: {} },
    mode: { type: String, default: "connect" }  // "connect" or "submit"
  }

  static targets = ["eventIdField"]

  connect() {
    if (typeof fbq === "undefined") return

    // Mode: connect = fire on page load (for content views)
    if (this.modeValue === "connect" && this.hasEventValue) {
      this.trackEvent()
    }
  }

  // Mode: submit = fire on form submit (for conversions)
  // Usage: data-action="submit->facebook-pixel#trackSubmit"
  trackSubmit() {
    if (typeof fbq === "undefined") return

    // Generate event_id if not provided
    const eventId = this.hasEventIdValue
      ? this.eventIdValue
      : this.generateEventId()

    // Fire Pixel immediately (before form submits)
    fbq("track", this.eventValue, this.paramsValue, { eventID: eventId })

    // Add event_id to form for server to read
    if (this.hasEventIdFieldTarget) {
      this.eventIdFieldTarget.value = eventId
    }

    // Form continues to submit normally
  }

  trackEvent() {
    const eventId = this.hasEventIdValue
      ? this.eventIdValue
      : this.generateEventId()

    fbq("track", this.eventValue, this.paramsValue, { eventID: eventId })
  }

  generateEventId() {
    const timestamp = Date.now()
    const random = Math.random().toString(36).substring(2, 9)
    return `${this.eventValue.toLowerCase()}_${timestamp}_${random}`
  }
}
